import { render, staticRenderFns } from "./ElementTask.vue?vue&type=template&id=665774c2&"
import script from "./ElementTask.vue?vue&type=script&lang=js&"
export * from "./ElementTask.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("G:\\CompanyProject\\HF-IM-sub-design\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('665774c2')) {
      api.createRecord('665774c2', component.options)
    } else {
      api.reload('665774c2', component.options)
    }
    module.hot.accept("./ElementTask.vue?vue&type=template&id=665774c2&", function () {
      api.rerender('665774c2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/bpmnProcessDesigner/package/penal/task/ElementTask.vue"
export default component.exports